// SearchWorkflowPage.tsx

import React from "react";
import SearchWorkflowContainer from "./SearchWorkflowContainer";
import CustomMenu from "../../components/CustomMenu/CustomMenu";

/**
 * ワークフロー検索ページコンポーネント
 * - カスタムメニュー内にワークフロー検索コンテナを表示する
 */
export default function SearchWorkflowPage() {
  return (
    <CustomMenu>
      <SearchWorkflowContainer />
    </CustomMenu>
  );
}
